// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202606180431/js/" + chunkId + "." + {"44":"060464f3","225":"8e00cb10","481":"17fa63d8","486":"4d446d3f","770":"d5e10d77"}[chunkId] + ".0.41285773487927535.chunk.js";
};